import { IEventDetailedRound } from '../../../../../store/admin/eventRounds/store';

import { IOpenGroups } from '../Context/TeeSheetCreator.context';
import { filterGroup } from './filterGroup';

export const search = (dispatch: any, round: IEventDetailedRound | null) => (evnt: any) => {
  const { value } = evnt.target;
  const roundGroups = (round as IEventDetailedRound).groups || [];
  const newFilteredGroups = roundGroups.filter(g => filterGroup(round, g, value));
  const newOpenGroups: IOpenGroups = !!value
    ? newFilteredGroups.reduce((open, group) => ({ ...open, [group.id]: true }), {})
    : {};

  dispatch({ type: 'set', value: { attribute: 'searchValue', value } });
  dispatch({ type: 'set', value: { attribute: 'openGroups', value: newOpenGroups } });
};
